import { atom } from "recoil";

const authAtom = atom({
  key: "authAtom",
  default: localStorage.getItem("dugro-i-auth")
    ? JSON.parse(localStorage.getItem("dugro-i-auth"))
    : null,
});

export default authAtom;
